import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9814f3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-container" }
const _hoisted_2 = {
  class: "flex account-box-container flex-col items-center md:flex-row",
  "data-cy": "account-container"
}
const _hoisted_3 = { class: "m-4 flex-auto" }
const _hoisted_4 = { class: "no-margin inline flex-1" }
const _hoisted_5 = {
  class: "label flex-1 grow inline-block",
  "data-cy": "label-name"
}
const _hoisted_6 = {
  class: "flex-1 grow inline-block text-right input",
  "data-cy": "userName"
}
const _hoisted_7 = {
  class: "label flex-1 grow inline-block",
  "data-cy": "label-email"
}
const _hoisted_8 = {
  class: "flex-1 grow inline-block text-right input",
  "data-cy": "userEmail"
}
const _hoisted_9 = {
  class: "label flex-1 grow inline-block",
  "data-cy": "label-selectLanguage"
}
const _hoisted_10 = { class: "relative h-48 w-48 md:h-72 md:w-72" }
const _hoisted_11 = {
  class: "container",
  "data-cy": "password-container"
}
const _hoisted_12 = { class: "boxed-container" }
const _hoisted_13 = { class: "m-4" }
const _hoisted_14 = { class: "app-info" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "boxed-container" }
const _hoisted_17 = { class: "m-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "app-info" }, " App Info ", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label flex-1 grow inline-block" }, " App Version ", -1))
const _hoisted_21 = { class: "flex-1 grow inline-block text-right input" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label flex-1 grow inline-block" }, " Backend Version ", -1))
const _hoisted_23 = { class: "flex-1 grow inline-block text-right input" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label flex-1 grow inline-block" }, " Frontend Url ", -1))
const _hoisted_25 = { class: "flex-1 grow inline-block text-right input" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label flex-1 grow inline-block" }, " Backend Url ", -1))
const _hoisted_27 = { class: "flex-1 grow inline-block text-right input" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label flex-1 grow inline-block" }, " Production Mode ", -1))
const _hoisted_29 = { class: "flex-1 grow inline-block text-right input" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label flex-1 grow inline-block" }, " Logs ", -1))
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserDialogButton = _resolveComponent("UserDialogButton")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_SelectLanguage = _resolveComponent("SelectLanguage")!
  const _component_IonImg = _resolveComponent("IonImg")!
  const _component_AInputMLStyle = _resolveComponent("AInputMLStyle")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_toolbar, {
        title: "Einstellungen",
        "show-back-button": "",
        onOnBackButtonClicked: () => {}
      }, {
        trailing: _withCtx(() => [
          _createVNode(_component_UserDialogButton)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.rowClass)
                }, [
                  _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("einstellungen.account")), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.rowClass, "inline float-right"])
                  }, [
                    _createVNode(_component_AButton, {
                      type: 'submit',
                      "data-cy": "button-logout",
                      "btn-secondary": true,
                      class: "mt-4",
                      onClick: _ctx.logout
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('buttons.logout')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 2)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.rowClass)
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("einstellungen.name")), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.username), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.rowClass)
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("einstellungen.email")), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.user.email), 1)
                ], 2),
                (_ctx.isDev)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.rowClass)
                    }, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("einstellungen.sprache")), 1),
                      _createVNode(_component_SelectLanguage)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_IonImg, {
                  "data-cy": "profileImage",
                  src: 
                _ctx.user.profilbild
                  ? _ctx.getPhotoUrl(_ctx.user.profilbild)
                  : './assets/img/profiles/placeholder_profile_image.png'
              ,
                  class: "rounded object-cover h-full",
                  style: {"background":"white"}
                }, null, 8, ["src"]),
                _createVNode(_component_AButton, {
                  "data-cy": "button-uploadProfileImage",
                  "btn-tertiary": true,
                  class: "px-12 py-4 absolute bottom-4 profile-edit-btn cursor-pointer",
                  onClick: _ctx.uploadProfileImage
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("buttons.aendern")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.rowClass)
                }, [
                  _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.$t("einstellungen.passwort")), 1)
                ], 2),
                _createElementVNode("form", {
                  novalidate: "",
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onChangePassword && _ctx.onChangePassword(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_AInputMLStyle, {
                      modelValue: _ctx.changePasswordForm.currentPassword.$model,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.changePasswordForm.currentPassword.$model) = $event)),
                      "data-cy": "input-currentPassword",
                      class: "pl-4",
                      "input-type": "password",
                      label: _ctx.t('einstellungen.aktuellesPasswort'),
                      errors: _ctx.changePasswordForm.currentPassword.$errors
                    }, null, 8, ["modelValue", "label", "errors"]),
                    _createVNode(_component_AInputMLStyle, {
                      modelValue: _ctx.changePasswordForm.newPassword.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.changePasswordForm.newPassword.$model) = $event)),
                      "data-cy": "input-newPassword",
                      class: "pl-4",
                      "input-type": "password",
                      label: _ctx.t('einstellungen.neuesPasswort'),
                      errors: _ctx.changePasswordForm.newPassword.$errors
                    }, null, 8, ["modelValue", "label", "errors"]),
                    _createVNode(_component_AInputMLStyle, {
                      modelValue: _ctx.changePasswordForm.confirmNewPassword.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.changePasswordForm.confirmNewPassword.$model) = $event)),
                      "data-cy": "input-confirmNewPassword",
                      class: "pl-4",
                      "input-type": "password",
                      label: _ctx.t('einstellungen.neuesPasswortBestätigen'),
                      errors: _ctx.changePasswordForm.confirmNewPassword.$errors
                    }, null, 8, ["modelValue", "label", "errors"])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _createVNode(_component_AButton, {
                      type: 'submit',
                      "btn-primary": true,
                      "data-cy": "button-updatePassword",
                      class: "mt-4",
                      style: {"margin-left":"auto","margin-right":"0px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("einstellungen.passwortAendern")), 1)
                      ]),
                      _: 1
                    })
                  ], 2)
                ], 32)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.rowClass)
                }, _hoisted_19, 2),
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.env.BUILD_VERSION), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.backendBuildVersion), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.env.SERVER_URL) + ":" + _toDisplayString(_ctx.env.SERVER_PORT), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.env.BACKEND_URL) + ":" + _toDisplayString(_ctx.env.BACKEND_PORT), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.env.production), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, _hoisted_31, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClass)
                  }, [
                    _createVNode(_component_AButton, {
                      type: 'button',
                      "btn-primary": true,
                      "data-cy": "button-showDebugLogs",
                      style: {"margin-left":"auto","margin-right":"0px"},
                      class: "mt-4",
                      onClick: _cache[4] || (_cache[4] = () => _ctx.goToLogs())
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Show Debugging Logs ")
                      ]),
                      _: 1
                    })
                  ], 2)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}